import script from "./IframeView.vue?vue&type=script&setup=true&lang=js"
export * from "./IframeView.vue?vue&type=script&setup=true&lang=js"

import "./IframeView.vue?vue&type=style&index=0&id=1e57d300&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e57d300"]])

export default __exports__